import API from './client';

export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  getMe: () => API.get('/auth/me'),
  updateProfile: (data) => API.put('/auth/profile', data),
  changePassword: (data) => API.put('/auth/password', data),
};

export const productAPI = {
  getAll: (params) => API.get('/products', { params }),
  getOne: (id) => API.get(`/products/${id}`),
  getBySlug: (slug) => API.get(`/products/${slug}`),
  getBestSellers: () => API.get('/products/best-sellers'),
  getSuggestions: (q) => API.get('/products/suggestions', { params: { q } }),
  addReview: (id, data) => API.post(`/products/${id}/reviews`, data),
  toggleWishlist: (productId) => API.post(`/products/${productId}/wishlist`),
  getWishlist: () => API.get('/products/wishlist'),
};

export const orderAPI = {
  create: (data) => API.post('/orders', data),
  getMyOrders: (params) => API.get('/orders/my-orders', { params }),
  getOne: (id) => API.get(`/orders/${id}`),
  getAll: (params) => API.get('/orders/admin/all', { params }),
  updateStatus: (id, data) => API.put(`/orders/${id}/status`, data),
  getStats: () => API.get('/orders/admin/stats'),
  markPaymentFailed: (data) => API.post('/orders/payment-failed', data),
};

export const paymentAPI = {
  createOrder: (amount) => API.post('/payment/create-order', { amount }),
  verifyPayment: (data) => API.post('/payment/verify', data),
  reportFailure: (data) => API.post('/payment/failure', data),
};

export const couponAPI = {
  validate: (code, subtotal, cartItems) => API.post('/coupons/validate', { code, subtotal, cartItems }),
  getAll: (params) => API.get('/coupons', { params }),
  create: (data) => API.post('/coupons', data),
  update: (id, data) => API.put(`/coupons/${id}`, data),
  delete: (id) => API.delete(`/coupons/${id}`),
  getAnalytics: () => API.get('/coupons/analytics'),
};

export const settingsAPI = {
  getPublic: () => API.get('/settings/public'),
  getAll: () => API.get('/settings'),
  update: (key, value) => API.put(`/settings/${key}`, { value }),
  updateBulk: (settings) => API.put('/settings/bulk', { settings }),
};

export const analyticsAPI = {
  getDashboard: () => API.get('/analytics/dashboard'),
  getRevenueTrend: (period) => API.get('/analytics/revenue', { params: { period } }),
  getUsers: (params) => API.get('/analytics/users', { params }),
};

export const uploadAPI = {
  uploadImages: (formData) =>
    API.post('/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};